(function () {
  const DESKTOP_QUERY = '(min-width: 1200px)';
  const THUMB_SIZE = 100;
  const THUMB_GAP = 8;
  const VISIBLE_THUMBS = 5;

  const getThumbsContentHeight = (thumbCount) => {
    if (thumbCount <= 0) {
      return 0;
    }

    return thumbCount * THUMB_SIZE + (thumbCount - 1) * THUMB_GAP;
  };

  const getVisibleThumbsHeight = () => {
    return VISIBLE_THUMBS * THUMB_SIZE + (VISIBLE_THUMBS - 1) * THUMB_GAP;
  };

  const syncThumbsViewport = (root, mainElement) => {
    const thumbsWrap = root.querySelector('[data-product-gallery-thumbs-wrap]');
    const thumbButtons = root.querySelectorAll('[data-product-gallery-thumb]');

    if (!thumbsWrap || !mainElement) {
      return;
    }

    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      thumbsWrap.style.maxHeight = '';
      return;
    }

    const thumbCount = thumbButtons.length;
    const contentHeight = getThumbsContentHeight(thumbCount);
    const visibleHeight = getVisibleThumbsHeight();
    const mainHeight = mainElement.getBoundingClientRect().height;

    if (thumbCount <= VISIBLE_THUMBS) {
      thumbsWrap.style.maxHeight = `${contentHeight}px`;
      return;
    }

    if (mainHeight > visibleHeight) {
      thumbsWrap.style.maxHeight = `${Math.min(mainHeight, contentHeight)}px`;
      return;
    }

    thumbsWrap.style.maxHeight = `${visibleHeight}px`;
  };

  const setActiveThumb = (root, activeIndex) => {
    const thumbs = root.querySelectorAll('[data-product-gallery-thumb]');

    thumbs.forEach((thumb, index) => {
      const isActive = index === activeIndex;

      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const scrollActiveThumbIntoView = (root) => {
    const activeThumb = root.querySelector('[data-product-gallery-thumb].is-active');

    if (!activeThumb) {
      return;
    }

    activeThumb.scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
      behavior: 'smooth',
    });
  };

  let shareToastElement = null;
  let shareToastTimeout = null;

  const showShareToast = (message) => {
    if (!message) {
      return;
    }

    if (!shareToastElement) {
      shareToastElement = document.createElement('div');
      shareToastElement.className = 'product-gallery__share-toast';
      shareToastElement.setAttribute('role', 'status');
      shareToastElement.setAttribute('aria-live', 'polite');
      document.body.appendChild(shareToastElement);
    }

    shareToastElement.textContent = message;
    shareToastElement.classList.add('is-visible');

    if (shareToastTimeout) {
      window.clearTimeout(shareToastTimeout);
    }

    shareToastTimeout = window.setTimeout(() => {
      shareToastElement.classList.remove('is-visible');
    }, 2500);
  };

  const getShareData = (shareRoot) => {
    return {
      url: shareRoot.dataset.shareUrl || '',
      title: shareRoot.dataset.shareTitle || '',
      image: shareRoot.dataset.shareImage || '',
      copyMessage: shareRoot.dataset.shareCopyMessage || '',
    };
  };

  const buildShareUrl = (platform, shareData) => {
    const encodedUrl = encodeURIComponent(shareData.url);
    const encodedTitle = encodeURIComponent(shareData.title);
    const encodedImage = encodeURIComponent(shareData.image);

    if (platform === 'facebook') {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    }

    if (platform === 'x') {
      return `https://x.com/share?url=${encodedUrl}&text=${encodedTitle}`;
    }

    if (platform === 'pinterest') {
      return `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`;
    }

    if (platform === 'linkedin') {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    }

    if (platform === 'whatsapp') {
      return `https://wa.me/?text=${encodeURIComponent(`${shareData.url} - ${shareData.title}`)}`;
    }

    if (platform === 'telegram') {
      return `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;
    }

    return '';
  };

  const closeShareMenus = (exceptShare) => {
    document.querySelectorAll('[data-product-gallery-share]').forEach((share) => {
      if (share === exceptShare) {
        return;
      }

      share.classList.remove('is-open');

      const toggle = share.querySelector('[data-product-gallery-share-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const initProductShare = () => {
    document.querySelectorAll('[data-product-gallery-share]').forEach((share) => {
      if (share.dataset.productGalleryShareInitialized === 'true') {
        return;
      }

      const toggle = share.querySelector('[data-product-gallery-share-toggle]');
      const menu = share.querySelector('[data-product-gallery-share-menu]');
      const copyButton = share.querySelector('[data-product-gallery-share-copy]');
      const platformButtons = share.querySelectorAll('[data-product-gallery-share-platform]');

      if (menu) {
        menu.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }

      platformButtons.forEach((platformButton) => {
        platformButton.addEventListener('click', (event) => {
          event.stopPropagation();

          const platform = platformButton.dataset.productGallerySharePlatform;
          const shareData = getShareData(share);
          const shareUrl = buildShareUrl(platform, shareData);

          if (!shareUrl) {
            return;
          }

          window.open(shareUrl, '_blank', 'noopener,noreferrer');
        });
      });

      if (toggle) {
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();

          if (!window.matchMedia(DESKTOP_QUERY).matches) {
            const isOpen = !share.classList.contains('is-open');

            closeShareMenus(share);

            if (isOpen) {
              share.classList.add('is-open');
              toggle.setAttribute('aria-expanded', 'true');
            } else {
              share.classList.remove('is-open');
              toggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }

      if (copyButton) {
        copyButton.addEventListener('click', async (event) => {
          event.stopPropagation();

          const shareData = getShareData(share);

          if (!shareData.url) {
            return;
          }

          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(shareData.url);
            } else {
              const textArea = document.createElement('textarea');
              textArea.value = shareData.url;
              textArea.setAttribute('readonly', '');
              textArea.style.position = 'absolute';
              textArea.style.left = '-9999px';
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand('copy');
              document.body.removeChild(textArea);
            }

            copyButton.classList.add('is-copied');
            showShareToast(shareData.copyMessage);

            window.setTimeout(() => {
              copyButton.classList.remove('is-copied');
            }, 1500);
          } catch (error) {
            copyButton.classList.remove('is-copied');
          }
        });
      }

      share.dataset.productGalleryShareInitialized = 'true';
    });

    if (!document.body.dataset.productGalleryShareBound) {
      document.addEventListener('click', () => {
        closeShareMenus(null);
      });

      document.body.dataset.productGalleryShareBound = 'true';
    }
  };

  const initProductGalleries = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-product-gallery]').forEach((root) => {
      if (root.dataset.productGalleryInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-product-gallery-main]');
      const prevButton = root.querySelector('[data-product-gallery-prev]');
      const nextButton = root.querySelector('[data-product-gallery-next]');
      const thumbButtons = root.querySelectorAll('[data-product-gallery-thumb]');

      if (!mainElement) {
        return;
      }

      const swiperOptions = {
        speed: 450,
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      const mainSwiper = new Swiper(mainElement, swiperOptions);

      const updateLayout = () => {
        syncThumbsViewport(root, mainElement);
      };

      thumbButtons.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.index);

          if (Number.isNaN(index)) {
            return;
          }

          mainSwiper.slideTo(index);
        });
      });

      mainSwiper.on('slideChange', () => {
        setActiveThumb(root, mainSwiper.activeIndex);
        scrollActiveThumbIntoView(root);
      });

      updateLayout();

      window.addEventListener('resize', updateLayout);

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateLayout);
        resizeObserver.observe(mainElement);
      }

      root.querySelectorAll('.product-gallery__image').forEach((image) => {
        if (image.complete) {
          updateLayout();
        } else {
          image.addEventListener('load', updateLayout, { once: true });
        }
      });

      root.dataset.productGalleryInitialized = 'true';
    });
  };

  const formatProductMoney = (cents) => {
    const amount = Math.round(Number(cents) || 0);
    const lira = Math.floor(amount / 100);
    const kurus = amount % 100;
    const str = String(lira);
    let formatted = '';
    let count = 0;

    for (let index = str.length - 1; index >= 0; index -= 1) {
      if (count > 0 && count % 3 === 0) {
        formatted = `${str.charAt(index)}.${formatted}`;
      } else {
        formatted = `${str.charAt(index)}${formatted}`;
      }

      count += 1;
    }

    if (kurus > 0) {
      const kurusString = kurus < 10 ? `0${kurus}` : String(kurus);
      formatted += `,${kurusString}`;
    }

    return `${formatted}\u00a0TL`;
  };

  const getWirePrice = (price, discountPercent) => {
    const wirePrice = Math.round((price * (100 - discountPercent)) / 100);
    return Math.round((wirePrice + 50) / 100) * 100;
  };

  const updateProductPrice = (priceRoot, variant) => {
    if (!priceRoot || !variant) {
      return;
    }

    const currentEl = priceRoot.querySelector('[data-product-price-current]');
    const compareEl = priceRoot.querySelector('[data-product-price-compare]');
    const compareValueEl = priceRoot.querySelector('[data-product-price-compare-value]');
    const badgeEl = priceRoot.querySelector('[data-product-price-badge]');
    const badgeValueEl = priceRoot.querySelector('[data-product-price-badge-value]');
    const wireEl = priceRoot.querySelector('[data-product-price-wire]');
    const showWirePrice = priceRoot.dataset.showWirePrice === 'true';
    const wireDiscount = Number.parseInt(priceRoot.dataset.wireDiscount, 10) || 0;
    const price = Number(variant.price) || 0;
    const compareAtPrice = Number(variant.compareAtPrice) || 0;
    const onSale = compareAtPrice > price;

    if (currentEl) {
      currentEl.textContent = formatProductMoney(price);
    }

    if (compareEl) {
      if (onSale) {
        compareEl.hidden = false;

        if (compareValueEl) {
          compareValueEl.textContent = formatProductMoney(compareAtPrice);
        }
      } else {
        compareEl.hidden = true;
      }
    }

    if (badgeEl) {
      if (onSale) {
        const discountPercent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);

        badgeEl.hidden = false;

        if (badgeValueEl) {
          badgeValueEl.textContent = `%${discountPercent}`;
        }
      } else {
        badgeEl.hidden = true;
      }
    }

    const wirePriceCents = showWirePrice ? getWirePrice(price, wireDiscount) : null;

    if (wireEl && showWirePrice) {
      wireEl.textContent = formatProductMoney(wirePriceCents);
    }

    document.dispatchEvent(
      new CustomEvent('joker:product-variant-price', {
        bubbles: true,
        detail: {
          priceCents: price,
          wirePriceCents: wirePriceCents,
        },
      })
    );
  };

  const selectProductVariant = (productInfo, variant) => {
    if (!productInfo || !variant) {
      return;
    }

    const form = productInfo.querySelector('[data-product-buy]');
    const priceRoot = productInfo.querySelector('[data-product-price]');
    const variantInput = form ? form.querySelector('[data-product-variant-id]') : null;
    const addButton = form ? form.querySelector('[data-product-add-to-cart]') : null;
    const sizeValueEl = productInfo.querySelector('[data-product-size-value]');
    const sizeOptions = productInfo.querySelectorAll('[data-product-size-option]');

    if (variantInput) {
      variantInput.value = String(variant.id);
    }

    updateProductPrice(priceRoot, variant);

    if (addButton) {
      const addText = form.dataset.addText || '';
      const stockAlertText = form.dataset.stockAlertText || '';
      const iconEl = addButton.querySelector('[data-stock-alert-icon]');
      const labelEl = addButton.querySelector('[data-buy-button-label]');

      if (variant.available) {
        addButton.type = 'submit';
        addButton.disabled = false;
        addButton.classList.remove('is-stock-alert');
        addButton.removeAttribute('data-stock-alert-trigger');
        if (iconEl) {
          iconEl.hidden = true;
        }
        if (labelEl) {
          labelEl.textContent = addText;
        }
      } else {
        addButton.type = 'button';
        addButton.disabled = false;
        addButton.classList.add('is-stock-alert');
        addButton.setAttribute('data-stock-alert-trigger', '');
        addButton.dataset.labelAdd = stockAlertText;
        addButton.dataset.labelAdding = form.dataset.stockAlertAddingText || stockAlertText;
        if (iconEl) {
          iconEl.hidden = false;
        }
        if (labelEl) {
          labelEl.textContent = stockAlertText;
        }
        addButton.dataset.variantGid = `gid://shopify/ProductVariant/${variant.id}`;
        const variantTitle = variant.title || variant.optionValue || '';
        addButton.dataset.variantTitle = String(variantTitle);
      }
    }

    if (sizeValueEl) {
      sizeValueEl.textContent = variant.optionValue || '';
    }

    sizeOptions.forEach((option) => {
      const isActive = Number.parseInt(option.dataset.variantId, 10) === variant.id;

      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const isQuickView = Boolean(productInfo.closest('[data-quick-view-content]'));

    if (!isQuickView) {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', nextUrl.toString());
    }

    document.dispatchEvent(
      new CustomEvent('joker:product-variant-selected', {
        bubbles: true,
        detail: {
          variantId: variant.id,
        },
      })
    );
  };

  const initProductSize = (scope = document) => {
    scope.querySelectorAll('[data-product-size]').forEach((root) => {
      if (root.dataset.productSizeInitialized === 'true') {
        return;
      }

      const dataEl = root.querySelector('[data-product-size-data]');
      const productInfo = root.closest('.product-info');

      if (!dataEl || !productInfo) {
        return;
      }

      let sizeData = null;

      try {
        sizeData = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      const variants = Array.isArray(sizeData.variants) ? sizeData.variants : [];

      root.querySelectorAll('[data-product-size-option]').forEach((button) => {
        button.addEventListener('click', () => {
          const variantId = Number.parseInt(button.dataset.variantId, 10);
          const variant = variants.find((entry) => entry.id === variantId);

          if (!variant) {
            return;
          }

          selectProductVariant(productInfo, variant);
        });
      });

      root.dataset.productSizeInitialized = 'true';
    });
  };

  const initProductBuy = (scope = document) => {
    scope.querySelectorAll('[data-product-buy]').forEach((form) => {
      if (form.dataset.productBuyInitialized === 'true') {
        return;
      }

      const quantityInput = form.querySelector('[data-product-buy-quantity]');
      const decreaseButton = form.querySelector('[data-product-buy-decrease]');
      const increaseButton = form.querySelector('[data-product-buy-increase]');

      const updateQuantity = (delta) => {
        if (!quantityInput) {
          return;
        }

        const currentValue = Number.parseInt(quantityInput.value, 10);
        const safeValue = Number.isNaN(currentValue) ? 1 : currentValue;
        const nextValue = Math.max(1, safeValue + delta);

        quantityInput.value = String(nextValue);
      };

      if (decreaseButton) {
        decreaseButton.addEventListener('click', () => {
          updateQuantity(-1);
        });
      }

      if (increaseButton) {
        increaseButton.addEventListener('click', () => {
          updateQuantity(1);
        });
      }

      form.dataset.productBuyInitialized = 'true';
    });
  };

  const initProductTabs = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((root) => {
      if (root.dataset.productTabsInitialized === 'true') {
        return;
      }

      const tabs = root.querySelectorAll('[data-product-tab]');
      const panels = root.querySelectorAll('[data-product-tab-panel]');

      const activateTab = (nextTab) => {
        const targetId = nextTab.getAttribute('data-product-tab');

        tabs.forEach((tab) => {
          const isActive = tab === nextTab;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-product-tab-panel') === targetId;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(tab);
        });
      });

      root.dataset.productTabsInitialized = 'true';
    });
  };

  const initProductInfo = (scope = document) => {
    initProductSize(scope);
    initProductBuy(scope);
  };

  const initProductPage = () => {
    initProductShare();
    initProductGalleries();
    initProductInfo(document);
    initProductTabs();
  };

  window.initProductInfo = initProductInfo;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }

  document.addEventListener('shopify:section:load', initProductPage);
})();
